import { defineStore } from "pinia";
import { ref } from "vue";
import { useAppStore } from "@shared/store/modules/app";

/**
 * pageMaximizeStore — 列表页「页面内放大」全局状态
 *
 * active=true 时布局层隐藏侧栏/顶栏（见 page-layout.scss --page-fullscreen）。
 * 由 usePageTableFullscreen / UiTableFullscreenBtn 驱动；
 * 离开路由时 composable 自动 exit。
 */
export const usePageMaximizeStore = defineStore("pageMaximize", () => {
    const active = ref(false);

    function enter() {
        active.value = true;
        useAppStore().closeSubMenu();
    }

    function exit() {
        active.value = false;
    }

    function toggle() {
        if (active.value) exit();
        else enter();
    }

    return { active, enter, exit, toggle };
});
